import React, { useEffect, useLayoutEffect } from "react";
import { Toaster } from "sonner";
import "./global.module.scss";
import { Routes } from "./routes/Routes";
import { useAppSelector } from "@src/store/hooks";
import mixpanel from "mixpanel-browser";
import { buildLaunchDarklyUserContext, getLaunchDarklyConfig } from "@src/config/launchDarkly";
import { useLDClient, withLDProvider } from "launchdarkly-react-client-sdk";
import { identifyUser } from "@src/utils/tracking";
import { applyAppFontSize } from "@src/utils/appFontSize.utils";
import { ErrorBoundary } from "@src/components/errorBoundary/ErrorBoundary";
import "./styles/styles.scss";

export const App: React.FC = () => {
	const theme = useAppSelector((state) => state.settings.theme);
	const appFontSize = useAppSelector((state) => state.settings.appFontSize);
	const { token, email, userCompanyName, nameId } = useAppSelector((state) => state.settings);
	const ldClient = useLDClient();

	useEffect(() => {
		if (!ldClient) return;
		ldClient.identify(buildLaunchDarklyUserContext({ userName: token ? nameId : null, email, companyName: userCompanyName }));
	}, [ldClient, token, nameId, email, userCompanyName]);

	useLayoutEffect(() => {
		applyAppFontSize(appFontSize);
	}, [appFontSize]);

	useEffect(() => {
		if (email) mixpanel.identify(email);
		if (userCompanyName) {
			mixpanel.register({
				"User Email": email || null,
				"Company Name": userCompanyName,
				"Last Active": new Date().toISOString(),
			});
		}
		identifyUser(nameId, email);
	}, [email, userCompanyName, nameId]);

	return (
		<div className={`theme--${theme}`}>
			<ErrorBoundary>
				<Routes />
			</ErrorBoundary>
			<Toaster duration={2000} position="top-center" expand={false} closeButton />
			<div id="modal"></div>
		</div>
	);
};

export default withLDProvider(getLaunchDarklyConfig())(App);
